// ============================================================================
// Yönetim Paneli kart tanımları — TEK doğruluk kaynağı.
// Hem /admin sayfası (pages/admin/index.tsx) hem de alt kısayol çubuğu
// (shortcuts/shortcut-catalog.ts) buradan beslenir. Yeni bir yönetim kartı
// eklenince otomatik olarak "Kısayollarım" çekmecesinde de sunulur.
//
// Bu dosya React içermez; ana bundle'a girmesi güvenlidir (admin sayfası lazy).
// ============================================================================

export interface AdminMenuItem {
  title: string;
  description: string;
  icon: string;
  iconColor: string;
  bgColor: string;
  to: string;
  group: string;
  extraLink?: { label: string; to: string };
}

export const adminMenuItems: AdminMenuItem[] = [
  {
    title: 'Menü Yönetimi',
    description:
      'Üst menüdeki başlıkları ve sayfaları (CRM, Raporlar, Tedarik …) ekleyin, sıralayın, gizleyin. Her maddenin hangi rollerde göründüğünü ya da herkese açık olduğunu tek bakışta görün.',
    icon: '/media/icons/duotone/Layout/Layout-top-panel-6.svg',
    iconColor: 'text-primary',
    bgColor: 'rgba(0, 158, 247, 0.08)',
    to: '/admin/menu-management',
    group: 'Sistem',
  },
  {
    title: 'Rehber Turları',
    description:
      'Özellik rehberlerini (walkthrough) yönetin: turu açıp kapatın, ilk girişte otomatik başlasın mı seçin, kimin tamamladığını görün, bir kullanıcı ya da herkes için sıfırlayıp yeniden gösterin, önizleyin.',
    icon: '/media/icons/duotone/Navigation/Route.svg',
    iconColor: 'text-info',
    bgColor: 'rgba(114, 57, 234, 0.08)',
    to: '/admin/feature-tours',
    group: 'Sistem',
  },
  {
    title: 'Tedarik Mail Günlüğü',
    description: 'talep@ kutusuna düşen ham mailleri, nasıl sınıflandıklarını ve yapay zeka çıktılarını inceleyin. Hatalı çözümlenen maili yeniden işleme kuyruğuna alabilirsiniz.',
    icon: '/media/icons/duotone/Code/Terminal.svg',
    iconColor: 'text-info',
    bgColor: 'rgba(114, 57, 234, 0.08)',
    to: '/admin/purchase-mail-log',
    group: 'Sistem',
  },
  {
    title: 'CRT Yönetim Sistemi',
    description: 'CRT Excel dosyalarını yönetin: müşteri senkronizasyonu, genel Excel import, S2W fatura kontrolü ve ürün indirim oranı analizi.',
    icon: '/media/icons/duotone/Files/Cloud-upload.svg',
    iconColor: 'text-success',
    bgColor: 'rgba(80, 205, 137, 0.08)',
    to: '/admin/crt-sync',
    group: 'Satış & Müşteri',
  },
  {
    title: 'Takip Verileri',
    description: 'Teklif PDF indirme istatistikleri ve sistemdeki önemli olayları zaman içinde izleyin.',
    icon: '/media/icons/duotone/Shopping/Chart-line1.svg',
    iconColor: 'text-primary',
    bgColor: 'rgba(0, 158, 247, 0.08)',
    to: '/admin/tracking-data',
    group: 'Analitik & Takip',
  },
  {
    title: 'Ürün Kontrolleri',
    description: 'Ürünleri görüntüleyin, düzenleyin, filtreleyin ve sıralayın.',
    icon: '/media/icons/duotone/Shopping/Box1.svg',
    iconColor: 'text-warning',
    bgColor: 'rgba(255, 199, 0, 0.08)',
    to: '/admin/products',
    group: 'Ürün & Stok',
  },
  {
    title: 'Apple-Store Fiyat Senkronu',
    description:
      'apple.com/tr mağaza fiyatlarını parça numarasıyla çekin; eşleşen ürünlerin sitedeki satış fiyatı Apple fiyatına, indirimli fiyatı ürün kuralına (yüzde / tutar / sabit) göre otomatik güncellensin. Bekleyen değişiklikleri tek tuşla uygulayın, koşu ve fiyat geçmişini izleyin.',
    icon: '/media/icons/duotone/Shopping/Price2.svg',
    iconColor: 'text-dark',
    bgColor: 'rgba(24, 28, 50, 0.06)',
    to: '/admin/apple-store-prices',
    group: 'Ürün & Stok',
  },
  {
    title: 'Varyasyon Yönetimi',
    description:
      "Ürünlerin renk / çip / RAM / depolama / ekran özelliklerini doldurun; aynı gruptaki ürünler otomatik varyant ağına dönüşür ve Ticimax ürün sayfasındaki widget'ta gösterilir.",
    icon: '/media/icons/duotone/Shopping/Sort1.svg',
    iconColor: 'text-info',
    bgColor: 'rgba(114, 57, 234, 0.08)',
    to: '/admin/varyasyon-yonetimi',
    group: 'Ürün & Stok',
  },
  {
    title: 'Stok Özellik Yönetimi',
    description:
      'Satılmış tüm Apple stok kodlarının model / işlemci / ekran / bellek / depolama / renk özelliklerini yönetin. Apple Satış Analizi raporundaki özellik filtrelerini ve Model Bazlı görünümü besler.',
    icon: '/media/icons/duotone/Shopping/Barcode.svg',
    iconColor: 'text-primary',
    bgColor: 'rgba(0, 158, 247, 0.08)',
    to: '/admin/stok-ozellik-yonetimi',
    group: 'Ürün & Stok',
  },
  {
    title: 'Proje Satışı Ürün Grubu Yönetimi',
    description: 'Proje satışı kalemlerinin ürün gruplarını kontrol edin, eksikleri tespit edin ve düzenleyin.',
    icon: '/media/icons/duotone/Shopping/Chart-bar2.svg',
    iconColor: 'text-primary',
    bgColor: 'rgba(0, 158, 247, 0.08)',
    to: '/admin/brand-works-product-groups',
    group: 'Ürün & Stok',
  },
  {
    title: 'Proje Satışı Teslim Yönetimi',
    description: 'Onaylanmış proje satışı kayıtlarını "Teslim Edildi" olarak işaretleyin.',
    icon: '/media/icons/duotone/Shopping/Box2.svg',
    iconColor: 'text-info',
    bgColor: 'rgba(114, 57, 234, 0.08)',
    to: '/admin/brand-works-delivery',
    group: 'Ürün & Stok',
  },
  {
    title: 'Satış Hedefleri Yönetimi',
    description: 'Çeyreklik satış hedeflerini oluşturun, düzenleyin ve performans takibi yapın.',
    icon: '/media/icons/duotone/Shopping/Chart-bar1.svg',
    iconColor: 'text-success',
    bgColor: 'rgba(80, 205, 137, 0.08)',
    to: '/admin/sales-targets',
    group: 'Satış & Müşteri',
  },
  {
    title: 'Kampanya Kontrol',
    description:
      'Bir stok kodunu sorgulayın; ürünün hangi tekliflerde, kimin tekliflerinde, kaç adet ve ne fiyattan teklif edildiğini görün ve seçtiklerinizi ilgili satışçılara kampanya ön bilgisi olarak iletin.',
    icon: '/media/icons/duotone/Communication/Send.svg',
    iconColor: 'text-danger',
    bgColor: 'rgba(241, 65, 108, 0.08)',
    to: '/admin/kampanya-kontrol',
    group: 'Satış & Müşteri',
  },
  {
    title: 'İletişim Bulucu (Apollo + RocketReach)',
    description:
      'Atanan müşterilerin çalışanlarını Apollo.io veya RocketReach üzerinden keşfedin; ünvana göre filtreleyin, e-posta ve LinkedIn bilgilerini açıp tek tıkla cari kartındaki ilgili kişilere kaydedin.',
    icon: '/media/icons/duotone/Communication/Adress-book1.svg',
    iconColor: 'text-info',
    bgColor: 'rgba(114, 57, 234, 0.08)',
    to: '/contact-finder',
    group: 'Satış & Müşteri',
  },
  {
    title: 'Zamanlanmış Görevler',
    description: 'Otomatik çalışan görevleri görüntüleyin ve manuel olarak tetikleyin.',
    icon: '/media/icons/duotone/Code/Time-schedule.svg',
    iconColor: 'text-primary',
    bgColor: 'rgba(0, 158, 247, 0.08)',
    to: '/admin/scheduled-jobs',
    group: 'Sistem',
  },
  {
    title: 'OneDrive Dosyaları',
    description: 'Microsoft 365 OneDrive üzerinde dosya yükleme, klasör yönetimi ve indirme işlemleri.',
    icon: '/media/icons/duotone/Files/Cloud-upload.svg',
    iconColor: 'text-primary',
    bgColor: 'rgba(0, 120, 212, 0.08)',
    to: '/admin/onedrive',
    group: 'Sistem',
  },
  {
    title: 'Fiyat Analizi Logları',
    description: 'Teklif oluştururken yapılan fiyat analizi sorgularını inceleyin ve eksik verileri tespit edin.',
    icon: '/media/icons/duotone/Shopping/Chart-line1.svg',
    iconColor: 'text-info',
    bgColor: 'rgba(114, 57, 234, 0.08)',
    to: '/admin/price-analysis-logs',
    group: 'Analitik & Takip',
  },
  {
    title: 'Seri Numaraları Sync',
    description: "DIA ERP'den satılmış seri numaralarını yıl bazlı senkronize edin ve veri durumunu takip edin.",
    icon: '/media/icons/duotone/Code/Time-schedule.svg',
    iconColor: 'text-danger',
    bgColor: 'rgba(241, 65, 108, 0.08)',
    to: '/admin/sold-serial-sync',
    group: 'Ürün & Stok',
  },
  {
    title: 'Sistem E-posta Şablonları',
    description:
      'Şifre sıfırlama, hatırlatıcı, potansiyel onay/red sonucu, portal ve rapor e-postaları dahil sistemin gönderdiği tüm otomatik e-postaların konu ve HTML tasarımını görüntüleyin, düzenleyin, önizleyin ve test gönderin.',
    icon: '/media/icons/duotone/Communication/Mail-opened.svg',
    iconColor: 'text-success',
    bgColor: 'rgba(80, 205, 137, 0.08)',
    to: '/admin/email-templates',
    group: 'İletişim & Bildirim',
  },
  {
    title: 'Zamanlanmış Mail Görevleri',
    description: 'Stok alım önerisi gibi otomatik e-posta bildirimlerinin alıcılarını ve zamanlamasını yönetin.',
    icon: '/media/icons/duotone/Communication/Mail-at.svg',
    iconColor: 'text-primary',
    bgColor: 'rgba(59, 130, 246, 0.08)',
    to: '/admin/scheduled-email-jobs',
    group: 'İletişim & Bildirim',
  },
  {
    title: 'Özel Paylaşım Linkleri',
    description: 'Proje satışları gibi sayfaları kimlik doğrulaması olmadan paylaşmak için özel linkler oluşturun ve yönetin.',
    icon: '/media/icons/duotone/Communication/Share.svg',
    iconColor: 'text-warning',
    bgColor: 'rgba(255, 199, 0, 0.08)',
    to: '/admin/share-links',
    group: 'Sistem',
    extraLink: { label: 'Logları İncele', to: '/admin/share-link-logs' },
  },
  {
    title: 'Sürüm Notları Yönetimi',
    description: 'Uygulama sürüm notlarını oluşturun, özelliklerini ekleyin ve kullanıcıların etkileşim durumlarını takip edin.',
    icon: '/media/icons/duotone/Home/Book-open.svg',
    iconColor: 'text-info',
    bgColor: 'rgba(114, 57, 234, 0.08)',
    to: '/admin/release-notes',
    group: 'İletişim & Bildirim',
  },
  {
    title: 'Duyuru Yönetimi',
    description: 'Kullanıcılara CRM bildirimi veya e-posta ile duyuru gönderin, alıcıları seçin ve etkileşim istatistiklerini takip edin.',
    icon: '/media/icons/duotone/General/Notifications1.svg',
    iconColor: 'text-danger',
    bgColor: 'rgba(241, 65, 108, 0.08)',
    to: '/admin/announcements',
    group: 'İletişim & Bildirim',
  },
  {
    title: 'Site Stok Kontrolü',
    description: 'Ticimax sitesindeki ürün stokları ile DIA ERP gerçek stoklarını karşılaştırın ve uyumsuzlukları tespit edin.',
    icon: '/media/icons/duotone/Shopping/Box2.svg',
    iconColor: 'text-success',
    bgColor: 'rgba(80, 205, 137, 0.08)',
    to: '/admin/site-stock-control',
    group: 'Ürün & Stok',
  },
  {
    title: 'Webhook Logları',
    description: 'Ticimax webhook isteklerini (sipariş, durum değişikliği, üye kaydı vb.) görüntüleyin, filtreleyin ve analiz edin.',
    icon: '/media/icons/duotone/Communication/Clipboard-list.svg',
    iconColor: 'text-warning',
    bgColor: 'rgba(255, 168, 0, 0.08)',
    to: '/admin/webhook-logs',
    group: 'Analitik & Takip',
  },
  {
    title: 'Kiralabunu Tıklama Raporu',
    description: 'E-ticaret sitesindeki "Kirala" butonu tıklamalarını analiz edin: en çok tıklanan ürünler, kategori kırılımı, günlük/aylık trend ve saat dağılımı.',
    icon: '/media/icons/duotone/Shopping/Chart-pie.svg',
    iconColor: 'text-success',
    bgColor: 'rgba(80, 205, 137, 0.08)',
    to: '/reports/kiralabunu',
    group: 'Analitik & Takip',
  },
  {
    title: 'Apple Notes Bağlantı Raporu',
    description: 'Apple Notes senkronizasyonuna kim bağlanmış, her kullanıcının kaç notu var ve en son ne zaman eşitlenmiş — kullanıcı bazında görün.',
    icon: '/media/icons/duotone/Communication/Write.svg',
    iconColor: 'text-primary',
    bgColor: 'rgba(114, 57, 234, 0.08)',
    to: '/reports/apple-notes-connections',
    group: 'Analitik & Takip',
  },
  {
    title: 'XML Data Yönetimi',
    description: 'Ticimax varyasyon eşleştirmelerini yönetin, eksik ürünleri tamamlayın ve site verilerini güncelleyin.',
    icon: '/media/icons/duotone/Files/File.svg',
    iconColor: 'text-info',
    bgColor: 'rgba(0, 158, 247, 0.08)',
    to: '/admin/xmldata-management',
    group: 'Ürün & Stok',
  },
  {
    title: 'Video Yönetimi',
    description: 'Nasıl yapılır videolarının kategorilerini ve içeriklerini yönetin.',
    icon: '/media/icons/duotone/Media/Youtube.svg',
    iconColor: 'text-danger',
    bgColor: 'rgba(241, 65, 108, 0.08)',
    to: '/admin/tutorial-videos',
    group: 'İletişim & Bildirim',
  },
  {
    title: 'Mükerrer Müşteri Kontrolü',
    description: 'Satışçılar arası benzer/aynı isimli müşteri kayıtlarını tespit edin.',
    icon: '/media/icons/duotone/General/Search.svg',
    iconColor: 'text-danger',
    bgColor: 'rgba(241, 65, 108, 0.08)',
    to: '/admin/duplicate-customers',
    group: 'Satış & Müşteri',
  },
  {
    title: 'Müşteri Durum Analizi',
    description: 'Firma adıyla tüm kayıtları, atama geçmişini, kanıtları ve çakışmaları sorgulayın; önerilen birleştirme/devir aksiyonlarını tek tıkla uygulayın.',
    icon: '/media/icons/duotone/General/Visible.svg',
    iconColor: 'text-primary',
    bgColor: 'rgba(0, 158, 247, 0.08)',
    to: '/admin/case-analysis',
    group: 'Satış & Müşteri',
  },
  {
    title: 'Pasif Müşteri Büyüklük Analizi',
    description: '18 ay+ hareketsiz carilerin çalışan sayısını Gemini ile araştırın; büyüklüğe göre filtreleyin, listeden çıkarın, Excel alın.',
    icon: '/media/icons/duotone/Home/Building.svg',
    iconColor: 'text-warning',
    bgColor: 'rgba(255, 199, 0, 0.08)',
    to: '/admin/passive-size-analysis',
    group: 'Satış & Müşteri',
  },
  {
    title: 'Manuel Potansiyel Takibi',
    description: 'Manuel eklenen potansiyelleri eklenme tarihine göre süzüp mevcut potansiyel ve gerçek müşterilerle benzerliğini kontrol edin.',
    icon: '/media/icons/duotone/General/Binocular.svg',
    iconColor: 'text-warning',
    bgColor: 'rgba(255, 199, 0, 0.08)',
    to: '/admin/manual-potential-tracking',
    group: 'Satış & Müşteri',
  },
  {
    title: 'Çapraz Teklif Takibi',
    description:
      'Satışçıların kendi müşterisi olmayan cari ve potansiyel müşterilere oluşturduğu teklifleri geçmişe dönük ve günlük takip edin (POLİMEKS/EATON tarzı devir senaryoları).',
    icon: '/media/icons/duotone/Navigation/Exchange.svg',
    iconColor: 'text-danger',
    bgColor: 'rgba(241, 65, 108, 0.08)',
    to: '/admin/cross-customer-quotes',
    group: 'Satış & Müşteri',
  },
  {
    title: 'Major Müşteri Eşleştirme',
    description: 'Major müşterileri DIA tarafındaki müşterilerle eşleştirin ve yönetin.',
    icon: '/media/icons/duotone/General/Attachment2.svg',
    iconColor: 'text-info',
    bgColor: 'rgba(114, 57, 234, 0.08)',
    to: '/admin/major-customer-matching',
    group: 'Satış & Müşteri',
  },
  {
    title: 'ISO 500 Hedef Firma Tespiti',
    description: 'iso500.org.tr listesini carilerinizle eşleştirip bizde kaydı olmayan büyük sanayi kuruluşlarını çıkarın.',
    icon: '/media/icons/duotone/Shopping/Chart-line1.svg',
    iconColor: 'text-primary',
    bgColor: 'rgba(0, 158, 247, 0.08)',
    to: '/admin/iso500-matching',
    group: 'Satış & Müşteri',
  },
  {
    title: 'İSO Üye Hedef Firma Tespiti',
    description: 'İSO üye listesini (Bilişim Sanayii vb.) carilerinizle eşleştirip bizde kaydı olmayan firmaları çıkarın.',
    icon: '/media/icons/duotone/General/Search.svg',
    iconColor: 'text-info',
    bgColor: 'rgba(114, 57, 234, 0.08)',
    to: '/admin/iso-uye-matching',
    group: 'Satış & Müşteri',
  },
  {
    title: 'Denetim Şirketleri Hedef Tespiti',
    description: 'Bağımsız denetim kuruluşları listesini (Excel) carilerinizle eşleştirip bizde kaydı olmayan firmaları çıkarın.',
    icon: '/media/icons/duotone/General/Search.svg',
    iconColor: 'text-warning',
    bgColor: 'rgba(255, 199, 0, 0.08)',
    to: '/admin/denetim-matching',
    group: 'Satış & Müşteri',
  },
  {
    title: 'Potansiyel Müşteri Dönüştürme',
    description: 'Potansiyel müşterileri DIA fatura kayıtlarıyla eşleştirerek gerçek müşteriye dönüştürün.',
    icon: '/media/icons/duotone/General/Star.svg',
    iconColor: 'text-success',
    bgColor: 'rgba(80, 205, 137, 0.08)',
    to: '/admin/potential-customer-conversions',
    group: 'Satış & Müşteri',
  },
  {
    title: 'Süre Uzatma Talepleri',
    description: 'Satış temsilcilerinin potansiyel müşteri süresi uzatma taleplerini inceleyin ve onaylayın.',
    icon: '/media/icons/duotone/General/Clock.svg',
    iconColor: 'text-warning',
    bgColor: 'rgba(255, 199, 0, 0.08)',
    to: '/admin/extension-requests',
    group: 'Satış & Müşteri',
  },
  {
    title: 'Gerçek Müşteri Süre Uzatma Talepleri',
    description: '400+ gün hareketsiz gerçek müşteriler için temsilcilerin süre uzatma taleplerini inceleyin ve onaylayın.',
    icon: '/media/icons/duotone/Home/Alarm-clock.svg',
    iconColor: 'text-info',
    bgColor: 'rgba(114, 57, 234, 0.08)',
    to: '/admin/dormant-extension-requests',
    group: 'Satış & Müşteri',
  },
  {
    title: 'Potansiyel Müşteri Yeniden Dağıtım',
    description: 'Süresi dolan potansiyel müşterileri round-robin yöntemiyle temsilcilere yeniden atayın.',
    icon: '/media/icons/duotone/General/User.svg',
    iconColor: 'text-primary',
    bgColor: 'rgba(0, 158, 247, 0.08)',
    to: '/admin/potential-customer-redistribution',
    group: 'Satış & Müşteri',
  },
  {
    title: 'Temsilci İzin Yönetimi',
    description: 'Satış temsilcilerinin izin günlerini girin; potansiyel müşteri takip süreleri otomatik güncellenir.',
    icon: '/media/icons/duotone/General/Settings-2.svg',
    iconColor: 'text-info',
    bgColor: 'rgba(0, 163, 137, 0.08)',
    to: '/admin/sales-staff-leaves',
    group: 'Satış & Müşteri',
  },
  {
    title: 'Yoldaki Ürünler Geldi Mi?',
    description: 'DIA mal alım faturalarını kontrol ederek yoldaki ürünlerin gelip gelmediğini tespit edin.',
    icon: '/media/icons/duotone/Shopping/Box2.svg',
    iconColor: 'text-success',
    bgColor: 'rgba(80, 205, 137, 0.08)',
    to: '/admin/potw-arrival-check',
    group: 'Ürün & Stok',
  },
  {
    title: 'Stok Hareket Tarihi Düzeltme',
    description: 'Durgun stok raporundaki yanlış son hareket tarihlerini manuel düzeltin veya kartı otomatik tespitten çıkarın.',
    icon: '/media/icons/duotone/Communication/Write.svg',
    iconColor: 'text-warning',
    bgColor: 'rgba(255, 199, 0, 0.08)',
    to: '/admin/stock-movement-overrides',
    group: 'Ürün & Stok',
    extraLink: { label: 'Durgun Stok Raporu →', to: '/reports/stock-movement-analysis' },
  },
  {
    title: 'Etkinlik Anketleri',
    description: 'Etkinlikler için anket oluşturun, QR ile paylaşın ve yanıtları takip edin.',
    icon: '/media/icons/duotone/Communication/Clipboard-list.svg',
    iconColor: 'text-primary',
    bgColor: 'rgba(0, 158, 247, 0.08)',
    to: '/admin/event-surveys',
    group: 'İletişim & Bildirim',
  },
  {
    title: 'Mailing Test (Brevo)',
    description: "Brevo e-posta entegrasyonunu test edin. Delivered, opened, clicked, bounced webhook event'lerini takip edin.",
    icon: '/media/icons/duotone/Communication/Mail-at.svg',
    iconColor: 'text-info',
    bgColor: 'rgba(114, 57, 234, 0.08)',
    to: '/admin/mailing-test',
    group: 'İletişim & Bildirim',
  },
  {
    title: 'Mailing Motor Ayarları',
    description: 'Mailing gönderim motorunun çalışma saatlerini, günlük/run başına e-posta limitlerini ve çalıştırma aralığını yapılandırın.',
    icon: '/media/icons/duotone/Communication/Outgoing-box.svg',
    iconColor: 'text-success',
    bgColor: 'rgba(80, 205, 137, 0.08)',
    to: '/admin/mailing-engine',
    group: 'İletişim & Bildirim',
  },
  {
    title: 'Mailing Motor Takvimi',
    description: 'Mailing motorunun çalışma planını ve ileriye dönük zamanlanmış mail gönderimlerini günlük takvim halinde raporlayın.',
    icon: '/media/icons/duotone/Code/Time-schedule.svg',
    iconColor: 'text-success',
    bgColor: 'rgba(80, 205, 137, 0.08)',
    to: '/admin/mailing-motor-calendar',
    group: 'İletişim & Bildirim',
  },
  {
    title: 'Mailing Şablonları',
    description: 'E-posta şablonlarını yönetin. Header, hero, body, CTA ve footer bölüm şablonları oluşturun ve düzenleyin.',
    icon: '/media/icons/duotone/Design/Component.svg',
    iconColor: 'text-danger',
    bgColor: 'rgba(241, 65, 108, 0.08)',
    to: '/admin/mailing-templates',
    group: 'İletişim & Bildirim',
  },
  {
    title: 'Mailing Raporları',
    description: 'Gönderilen e-postaların teslim, açılma, tıklanma ve bounce oranlarını detaylı raporlarla analiz edin.',
    icon: '/media/icons/duotone/Communication/Chat6.svg',
    iconColor: 'text-warning',
    bgColor: 'rgba(255, 168, 0, 0.08)',
    to: '/admin/mailing-reports',
    group: 'İletişim & Bildirim',
  },
  {
    title: 'Ziraat 6 Taksit Raporu',
    description: 'Haziran 2026 döneminde Ziraat Bankası kredi kartı ile 6 taksit seçeneği kullanılarak verilen siparişlerin raporu.',
    icon: '/media/icons/duotone/Shopping/Credit-card.svg',
    iconColor: 'text-danger',
    bgColor: 'rgba(220, 53, 69, 0.08)',
    to: '/reports/ziraat-installment-report',
    group: 'İletişim & Bildirim',
  },
  {
    title: 'TBB Üyelik Doğrulama',
    description: 'Türkiye Barolar Birliği üyelik doğrulaması yapın ve sorgu loglarını görüntüleyin.',
    icon: '/media/icons/duotone/General/Shield-check.svg',
    iconColor: 'text-info',
    bgColor: 'rgba(114, 57, 234, 0.08)',
    to: '/admin/tbb-verification',
    group: 'Sistem',
  },
  {
    title: 'TBB Doğrulama Raporu',
    description: 'Barolar Birliği doğrulamalarının başarılı/başarısız sayıları ve gün bazlı grafiksel raporu.',
    icon: '/media/icons/duotone/Shopping/Chart-bar1.svg',
    iconColor: 'text-primary',
    bgColor: 'rgba(114, 57, 234, 0.08)',
    to: '/admin/tbb-report',
    group: 'Sistem',
  },
  {
    title: 'Kullanıcı Aktiflik Durumu',
    description: 'Sistemdeki kullanıcıların anlık çevrimiçi/çevrimdışı durumunu takip edin.',
    icon: '/media/icons/duotone/General/User.svg',
    iconColor: 'text-success',
    bgColor: 'rgba(80, 205, 137, 0.08)',
    to: '/admin/user-activity',
    group: 'Analitik & Takip',
  },
  {
    title: 'Sistem İzleme Panosu',
    description:
      'Ekranda sabit bırakılıp izlenen canlı pano: kim çevrimiçi, kim hangi kaydı ekledi/düzenledi/sildi, hangi zamanlanmış iş çalıştı ve sonucu, sistem sağlığı. Tam ekran destekler.',
    icon: '/media/icons/duotone/Devices/Display1.svg',
    iconColor: 'text-primary',
    bgColor: 'rgba(0, 158, 247, 0.08)',
    to: '/admin/system-monitor',
    group: 'Analitik & Takip',
  },
  {
    title: 'DIA Kontör Takibi',
    description:
      'DIA web servis kontör tüketimini izleyin: kalan bakiye, seçilen tarih aralığında harcanan kontör ve tahmini çağrı sayısı, gün/saat kırılımı, kontör yüklemeleri ve bakiyenin tahmini bitiş tarihi.',
    icon: '/media/icons/duotone/Shopping/Credit-card.svg',
    iconColor: 'text-primary',
    bgColor: 'rgba(0, 158, 247, 0.08)',
    to: '/admin/dia-kontor',
    group: 'Analitik & Takip',
  },
  {
    title: 'Akakçe Tarama Geçmişi',
    description:
      "Mac'teki günlük Akakçe piyasa fiyatı taramalarını izleyin: koşu başına işlenen ürün, değişen fiyat, çekilemeyen ürünler ve hata oranı, CRM'e aktarım sonucu, sürekli çekilemeyen stok kodları ve ana DB'de olmayan kodlar.",
    icon: '/media/icons/duotone/Shopping/Price1.svg',
    iconColor: 'text-danger',
    bgColor: 'rgba(241, 65, 108, 0.08)',
    to: '/admin/akakce-scans',
    group: 'Analitik & Takip',
  },
  {
    title: 'Canlı Kullanıcı Takibi',
    description: 'Kullanıcıların hangi sayfada olduğunu, aktif/boşta durumunu ve son işlemlerini gerçek zamanlı izleyin.',
    icon: '/media/icons/duotone/Shopping/Chart-line1.svg',
    iconColor: 'text-primary',
    bgColor: 'rgba(0, 158, 247, 0.08)',
    to: '/admin/live-activity',
    group: 'Analitik & Takip',
  },
  {
    title: 'Masaüstü Sürüm Yönetimi',
    description:
      'Masaüstü uygulamasının kurulum dosyalarını (macOS/Windows) ve arayüz güncellemelerini yükleyip yayına alın. Yayınlanan sürüm indirme butonuna ve kurulu uygulamalara otomatik yansır.',
    icon: '/media/icons/duotone/Devices/Laptop.svg',
    iconColor: 'text-primary',
    bgColor: 'rgba(0, 158, 247, 0.08)',
    to: '/admin/desktop-versions',
    group: 'Sistem',
  },
  {
    title: 'Veritabanı Yedek Yönetimi',
    description: 'Otomatik ve manuel veritabanı yedeklerini görüntüleyin, anlık yedek alın, indirme/silme ve geri yükleme işlemlerini güvenle yönetin.',
    icon: '/media/icons/duotone/Files/Cloud-upload.svg',
    iconColor: 'text-primary',
    bgColor: 'rgba(0, 158, 247, 0.08)',
    to: '/admin/db-backups',
    group: 'Sistem',
  },
  {
    title: 'Felaket Kurtarma',
    description:
      'Sistem tamamen çökerse yeni sunucunun kurulacağı OneDrive kasasını (şifreli gizli bilgiler, kaynak kod, yüklenen dosyalar) izleyin ve güncelleyin; sertifika bitişleri, hazırlık listesi ve tatbikat kayıtları tek ekranda.',
    icon: '/media/icons/duotone/General/Shield-protected.svg',
    iconColor: 'text-danger',
    bgColor: 'rgba(241, 65, 108, 0.08)',
    to: '/admin/disaster-recovery',
    group: 'Sistem',
  },
  {
    title: 'Doküman Yönetimi',
    description: 'Sistem dokümanlarını yükleyin, kategorize edin ve kullanıcılarla paylaşın.',
    icon: '/media/icons/duotone/Files/Folder-cloud.svg',
    iconColor: 'text-info',
    bgColor: 'rgba(114, 57, 234, 0.08)',
    to: '/admin/documents',
    group: 'Sistem',
  },
  {
    title: 'Portal Kullanıcıları',
    description:
      'Kurumsal Servis Portalı kullanıcılarını yönetin: davet e-postası gönderin, cari bağlantılarını ve rollerini (onaylayıcı/görüntüleyici) düzenleyin, hesapları aktif/pasif yapın.',
    icon: '/media/icons/duotone/Communication/Add-user.svg',
    iconColor: 'text-primary',
    bgColor: 'rgba(0, 158, 247, 0.08)',
    to: '/admin/portal-users',
    group: 'Satış & Müşteri',
    extraLink: { label: 'Portal Talepleri →', to: '/admin/portal-requests' },
  },
  {
    title: 'Portal Talepleri',
    description:
      'Kurumsal Servis Portalı üzerinden gelen servis taleplerini inceleyin, durum ve personel notu güncelleyin, DIA servis formuna bağlayın; SHY senkronunu tetikleyip kontör kullanımını izleyin.',
    icon: '/media/icons/duotone/Communication/Clipboard-list.svg',
    iconColor: 'text-success',
    bgColor: 'rgba(80, 205, 137, 0.08)',
    to: '/admin/portal-requests',
    group: 'Satış & Müşteri',
  },
  {
    title: 'İnsan Kaynakları',
    description: 'AI destekli CV ön eleme: iş ilanından kıstas üretimi, toplu CV yükleme, otomatik puanlama, gelişmiş filtreleme ile eleme ve görüşme notları.',
    icon: '/media/icons/duotone/Communication/Group.svg',
    iconColor: 'text-primary',
    bgColor: 'rgba(0, 158, 247, 0.08)',
    to: '/admin/insan-kaynaklari',
    group: 'İnsan Kaynakları',
  },
];

export const ADMIN_GROUP_ORDER = ['Analitik & Takip', 'Satış & Müşteri', 'Ürün & Stok', 'İletişim & Bildirim', 'İnsan Kaynakları', 'Sistem'];
